// Actions
export const API_RESPONSE_SUCCESS = "API_RESPONSE_SUCCESS";
export const API_RESPONSE_ERROR = "API_RESPONSE_ERROR";
export const GET_BALANCEOVERVIEW_CHARTS_DATA = "GET_BALANCEOVERVIEW_CHARTS_DATA";
export const GET_DIALTYPE_CHARTS_DATA = "GET_DIALTYPE_CHARTS_DATA"
export const GET_SALESFORECAST_CHARTS_DATA = "GET_SALESFORECAST_CHARTS_DATA";